import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { OutboxEntry } from '@sportschool/shared-logic';

/** Maps the server error code of a rejected outbox entry to a translated message (`errors.<code>`), with a generic fallback. */
export function useOutboxErrorMessage() {
  const { t, i18n } = useTranslation();
  return useCallback(
    (entry: Pick<OutboxEntry, 'errorCode'>): string => {
      const key = entry.errorCode ? `errors.${entry.errorCode}` : '';
      return key && i18n.exists(key) ? String(i18n.t(key as never)) : t('sync.errorGeneric');
    },
    [i18n, t]
  );
}
